import { toast } from 'react-toastify';
import type { AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getLoginPartialPath, getLogoutUrl } from '@common/libs/auth';
import { useLocalStorage } from 'usehooks-ts';
import { handleAxiosErrorMessage } from '@common/utils/axios-error-message';

const RETRY_COUNT = 3;
const LOGIN_ATTEMPTS = 'loginAttempts';

export function useAxiosInterceptors() {
  const navigate = useNavigate();
  const loginPath = getLoginPartialPath();
  const [loginAttempts, setLoginAttempts] = useLocalStorage(LOGIN_ATTEMPTS, 0);

  const resetLoginAttempts = () => setLoginAttempts(0);

  const handleResponseSuccess = (response: AxiosResponse) => {
    if (loginAttempts > 0) resetLoginAttempts();
    return response.data;
  };

  const handleResponseError = (error: AxiosError) => {
    const message = handleAxiosErrorMessage(error);
    let noToast = false;

    if (axios.isAxiosError(error) && error.response) {
      const { status } = error.response;
      if (status === 401) {
        noToast = true;
        setLoginAttempts((prev) => prev + 1);
        if (loginAttempts >= RETRY_COUNT) {
          navigate(getLogoutUrl());
          resetLoginAttempts();
        } else {
          navigate(loginPath);
        }
      }

      if (status === 429) {
        noToast = true;
      }
    }

    if (!noToast) toast.error(message);

    return Promise.reject(error);
  };

  return {
    handleResponseSuccess,
    handleResponseError,
  };
}
